import React from 'react';

/**
 * Track utag.view or utag.link events.
 */

export const TealiumContext = /*#__PURE__*/React.createContext(undefined);